module.exports = __webpack_public_path__ + "static/media/os.3eef8686.png";